import React from 'react';
import Layout from '@components/layout/Layout';
import styled from 'styled-components';
import { styles } from '@components/utils';
import breakpoints from '@repo/ui-components/breakpoints';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';
import KurgoContainer from '@components/utils/ContainerStyles';
import Breadcrumb from '@components/breadcrumb';
import createOpenGraphTags from '@repo/utils/createOpenGraphTags';

const title = `Kurgo Dog Products - Not Found`;

const PageNotFound = () => (
  <Layout
    headTagData={{
      title,
      description:
        'Kurgo is a leading supplier of quality dog travel supplies, seat covers, harnesses & accessories for active dogs. Click to learn more about our dog accessories.',
      keywords:
        'Dog travel, dog outdoors, dog training, dog trip, dog car, dog hike',
      meta: createOpenGraphTags(
        {
          title,
          url: '/404',
        },
        'Kurgo'
      ),
    }}
  >
    <KurgoContainer backgroundColor={styles.colors.gray[100]}>
      <Breadcrumb
        elements={[
          { text: 'Home', link: '/' },
          { text: 'Error', link: '/404' },
        ]}
      />
      <PageWrapper>
        <TextContainer>
          <h2>404 Error - Page Not Found</h2>
          <p>
            Uh oh, looks like the page you are looking for has moved or no
            longer exists.
          </p>
        </TextContainer>
        <SearchContainer>
          <form method="GET" action="/search">
            <SearchInput name="q" id="q" type="text" required />
            <SearchButton>Search</SearchButton>
          </form>
        </SearchContainer>
      </PageWrapper>
    </KurgoContainer>
  </Layout>
);

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const SearchButton = styled.button`
  background: ${styles.colors.orange[500]};
  color: white;
  border-color: transparent;
  font-size: ${styles.fontSize.base};
  padding: 8px 26px;

  &:hover {
    cursor: pointer;
    background: ${styles.colors.blue[500]};
  }
`;

const SearchContainer = styled.div`
  @media screen and (min-width: ${breakpoints.md}) {
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const SearchInput = styled.input`
  border: 1px solid ${styles.colors.gray[200]};
  color: ${styles.colors.gray[200]};
  font-size: ${styles.fontSize.base};
  padding: 13px 20px;
  width: 100%;
  margin-bottom: 15px;

  &:focus {
    outline: 0;
  }
`;

export default PageNotFound;
